var BackgroundSwicher = {};

BackgroundSwicher.refresh = function () {
  $.each($('.js-bg-switch'), function () {
		let breakPoint = $(this).data('bg-breakpoint');
		if (breakPoint == undefined) {
			breakPoint = 1023.98;
		}
		$(this).backgroundSwitcher({
			breakpoint: breakPoint,
		});
  });
};

BackgroundSwicher.refresh();

$(window).resize(BackgroundSwicher.refresh);

window.BackgroundSwicher = BackgroundSwicher;



// WEBPACK FOOTER //
// ./scripts/components/backgroundSwitch.js